import { DefaultTheme } from 'styled-components';

const light:DefaultTheme = {
  title: 'light',
  
  colors: {
    primary: '#6C63FF',
    secondary: '#FFAD7D',
    tertiary: '#68FF4A',

    background: '#E6F5FF',
    foreground: '#FFF',
    title: '#373737',
    text: '#1A1A1A' 
  }
}

export default light;